import { t } from "@/composables/translateText.js";

const columnLetters = ['a', 'b', 'c', 'd','e','f','g','h']

export function buildPieceLocationStrings (board,isPlayingWhite) {
  var whiteKing = ""
  var whiteQueens = []
  var whiteRooks = []
  var whiteBishops = []
  var whiteKnights = []
  var whitePawns = []

  var blackKing = ""
  var blackQueens = []
  var blackRooks = []
  var blackBishops = []
  var blackKnights = []
  var blackPawns = []

  var whitePieces = []
  var blackPieces = []

  
  //console.log("*** BOARD",board)

  for (var row=0; row < 8; row++) {
    for (var col=0; col < 8; col++) {
      if (board[row][col] == null)
        continue
      const oneSquare = board[row][col]
      //console.log("oneSquare",oneSquare)
      const san = ((oneSquare.type == 'p') ? "" : oneSquare.type.toUpperCase()) + oneSquare.square
      //console.log("square row col ",row,col,san)
      if (oneSquare.color == 'b') {
        switch (oneSquare.type) {
          case 'k' :
            blackKing = san
            break
          case 'q' :
            blackQueens.push(san)
            break
          case 'r' :
            blackRooks.push(san)
            break
          case 'b' :
            blackBishops.push(san)
            break
          case 'n' :
            blackKnights.push(san)
            break;
          case 'p' :
            blackPawns.push(san)
            break;
        }
      }
      else {
        switch (oneSquare.type) {
          case 'k' :
            whiteKing = san
            break
          case 'q' :
            whiteQueens.push(san)
            break
          case 'r' :
            whiteRooks.push(san)
            break
          case 'b' :
            whiteBishops.push(san)
            break
          case 'n' :
            whiteKnights.push(san)
            break;
          case 'p' :
            whitePawns.push(san)
            break;
        }
      }
    }
  }
  whitePieces.push(whiteKing)
  whiteQueens.forEach((currentElement) => { whitePieces.push(currentElement) })
  whiteRooks.forEach((currentElement) => { whitePieces.push(currentElement) })
  whiteBishops.forEach((currentElement) => { whitePieces.push(currentElement) })
  whiteKnights.forEach((currentElement) => { whitePieces.push(currentElement) })
  whitePawns.forEach((currentElement) => { whitePieces.push(currentElement) })

  blackPieces.push(blackKing)
  blackQueens.forEach((currentElement) => { blackPieces.push(currentElement) })
  blackRooks.forEach((currentElement) => { blackPieces.push(currentElement) })
  blackBishops.forEach((currentElement) => { blackPieces.push(currentElement) })
  blackKnights.forEach((currentElement) => { blackPieces.push(currentElement) })
  blackPawns.forEach((currentElement) => { blackPieces.push(currentElement) })

  const whitePieceString = t("White") + " : " + whitePieces.join(" ")
  const blackPieceString = t("Black") + " : " + blackPieces.join(" ")
  //console.log("white",whitePieceString)
  //console.log("black",blackPieceString)
  //console.log("orientation in initial",orientation.value)
  if (isPlayingWhite) {
  
    return {your : whitePieceString, opponent : blackPieceString}
  }
  return {your : blackPieceString, opponent : whitePieceString}
}

export function listOfSquaresWithNewPieces(originalBoard,newBoard) {
  //console.log("***** ORIGINAL ",originalBoard)
  //console.log("***** NEW      ",newBoard)
  var ucis = []
  for (var row=0; row < 8; row++)
    for (var col=0; col < 8; col++) {
      const oneOriginal = originalBoard[row][col]
      const oneNew = newBoard[row][col]
      if (oneNew == null)
        continue
      if (oneOriginal == null) {
        ucis.push(oneNew.square)
        continue
      }
      if (oneOriginal.type == oneNew.type && oneOriginal.color == oneNew.color)
        continue
      ucis.push(oneOriginal.square)
    }
  return (ucis)
}

// builds the KQkq string based on if the king and rooks are in the right place
export function buildCastleString(board) {

  var blackQueenRook = false
  var blackKingRook = false
  var blackKing = false
  var whiteQueenRook = false
  var whiteKingRook = false
  var whiteKing = false

  var castleString = ""

  for (var row=0; row < 8; row++)
    for (var col=0; col < 8; col++) {
      const oneSquare = board[row][col]
      if (oneSquare == null)
        continue
      switch (oneSquare.square) {
        case "a8" :
          blackQueenRook = (oneSquare.type == 'r' && oneSquare.color == 'b')
          break
        case "h8" :
          blackKingRook = (oneSquare.type == 'r' && oneSquare.color == 'b')
          break
        case "e8" :
          blackKing = (oneSquare.type == 'k' && oneSquare.color == 'b')
          break
        case "a1" :
          whiteQueenRook = (oneSquare.type == 'r' && oneSquare.color == 'w')
          break
        case "h1" :
          whiteKingRook = (oneSquare.type == 'r' && oneSquare.color == 'w')
          break
        case "e1" :
          whiteKing = (oneSquare.type == 'k' && oneSquare.color == 'w')
          break
      }
    }
  if (whiteKing) {
    if (whiteKingRook)
      castleString += "K"
    if (whiteQueenRook)
      castleString += "Q"
  }

  if (blackKing) {
    if (blackKingRook)
      castleString += "k"
    if (blackQueenRook)
      castleString += "q"
  }

  if (castleString.length == 0)
    return ("-")
  return (castleString)
}

export function getPieceSetName(blindfoldLevel) {
  const blindfoldValue = (typeof blindfoldLevel === 'string') ? parseInt(blindfoldLevel) : blindfoldLevel
  switch (blindfoldValue) {
    case 0 :
    case 1 :
      return ("regular")
      break
    case 2 : 
      //console.log("set blindness 2")
      return ("one_color")
      break
    case 3 :
      return ("two_disks")
      break
    case 4 :
      return ("one_disk")
      break
    case 5 :
      return ("invisible")
      break
  }
  return ("regular")
}

export function columnToNumber(letter) {
  for (var i =0; i < 8; i++)
    if (letter == columnLetters[i])
      return (i)
  return (0)
}

export function squarePairToAlgebraic(pair) {
  const squares = [Math.floor(pair / 100) , (pair % 100)]

  //console.log("squares ",squares)
  var notation = []
  for (var i=0; i < 2; i++) {
    const row = 8 - Math.floor(squares[i] / 8)
    const col = squares[i] % 8
    const n = columnLetters[col] + row
    notation.push(n)
  }
  const stringForArrow = notation.join("-")
  return (stringForArrow)
}

// uses chess.js to get the list of moves. This parses that list and builds "Available Moves"
//      chess.load(fen)
//      const moves = chess.moves({ verbose: true })

export function buildAvailableMoves(moves,allowAnyPromotion) {
  //console.log("MOVES",moves)
  var promotion = ""
  var availableMoves = []
  //console.log("build available moves",moves)
  for (var i=0; i < moves.length; i++) {
    const oneChessMove = moves[i]

    if (oneChessMove.san.includes("=")) {
      if (oneChessMove.san.includes("=Q") == false)
        continue;
      promotion = "q"
    }

    var tmp = oneChessMove.from.split("")
    var colNumber = columnToNumber(tmp[0])
    const fromSquareNumber = (8 - tmp[1]) * 8 + colNumber

    tmp = oneChessMove.to.split("")
    colNumber = columnToNumber(tmp[0])
    const toSquareNumber = (8 - tmp[1]) * 8 + colNumber

    const toArray = oneChessMove.to.split("")
    const fromArray = oneChessMove.from.split("")

    const oneMove = {   arrayIndex : i,
                        fen : oneChessMove.after,
                        from : fromSquareNumber,
                        to : toSquareNumber,
                        san : oneChessMove.san,
                        castle : "",
                        check : "",
                        passant : "",
                        promotion : promotion,
                        chessjs : oneChessMove }
    availableMoves.push(oneMove)
  }
  return (availableMoves)
}

 export function findValueString(strings,values,currentValue) {

    // all the values are strings, not sure what is coming from the initial load
    const current = (typeof currentValue !== 'string') ? String(currentValue) : currentValue
    for (var i=0; i < strings.length; i++) {
      if (current == values[i])
        return (strings[i])
    }
    return (t("Unknown"))
  }

function calcButtonLayout(buttonArray,isPortrait) {
  const buttonCount = buttonArray.length

  var buttonMatrix = []
  const rows = [ 0, 1, 2, 2, 2, 3, 3, 4, 4]
  const cols = [ 0, 1, 1, 2, 2, 2, 2, 2, 2]

  for (var index=0, row=0; row < rows[buttonCount]; row++) {
    var newRow = []
    for (var col=0; col < cols[buttonCount]; col++,index++) {
      newRow.push( (index < buttonCount) ? buttonArray[index] : null)
    }
    buttonMatrix.push({ index : row, items: newRow })
  }
  //console.log("buttonMatrix",buttonMatrix)
  return (buttonMatrix)
}

function pieceImage(color,piece,blindnessLevel) {
  const dir = "img/chesspieces/wikipedia/"
  const pieceUpper = piece.toUpperCase()
  const ext = ".svg"
  //console.log("Piece image",color,piece,blindnessLevel)

  switch (blindnessLevel) {
      case 0 :
      case 1 :
        return (dir + color + pieceUpper + ext)
        break
      case 2 : // shared color
        return (dir + "w" + pieceUpper + ext)
        break
      case 3 : // two color disks
        if (color == "w")
          return (dir + "white_disk_small.png")
        return (dir + "black_disk_small.png")
        break
      case 4 : // one color disk
        return (dir + "white_disk_small.png")
        break
      case 5 :
        return (dir + "invisible_disk.png")
        break
    }
  return (dir + color + pieceUpper + ext)
}

// turn ["a3","a4","a5","a6"]. into "a3 - a6".  also note if piece is on file then might be in the middle
function collapseConsecutiveToSquares(uniqueArray,pieceFromSquare) {
  if (uniqueArray.length == 0)
    return ("")
  if (uniqueArray.length == 1)
    return (uniqueArray[0])
  if (uniqueArray.length == 2)
    return (uniqueArray[0] + " & " + uniqueArray[1])

  const pieceOnSameFile = (pieceFromSquare[0] == uniqueArray[0][0])
  const firstRank = Number(uniqueArray[0][1])
  const lastRank = Number(uniqueArray[uniqueArray.length-1][1])
  if (lastRank - firstRank + 1 == uniqueArray.length ||
        (pieceOnSameFile && lastRank - firstRank == uniqueArray.length)) {
    const returnString = uniqueArray[0] + " - " + uniqueArray[uniqueArray.length-1]
    return (returnString)
  }
  else
    return (uniqueArray.join(","))
}

// subdivides a set of moves into a set of not more than 8 buttons
export function buildEyegazeButtons(moves,isPortrait,blindnessLevel) {

  // force a sort order
  const pieceNames = [
    ['p', 'aPawn'],
    ['r', 'bRook'],
    ['n', 'cKnight'],
    ['b', 'dBishop'],
    ['q', 'eQueen'],
    ['k', "fKing"]
  ]

  const pieceNameMap = new Map(pieceNames);

  //console.log("MOVES",moves)

  const pieceMap = new Map()
  const pieceFromSquare = new Map()
  const pieceFromSquareToFile = new Map()
  const pieceFromSquareToSquare = new Map()

  for (var i=0; i < moves.length; i++) {
    var oneMove = moves[i]

    // only allow queen promotions
    if (oneMove.san.includes("=")) {
      if (oneMove.san.includes("=Q") == false)
        continue;
    }

    // for blindfold chess, treat each "file" as a diffent group so on the initial board position,
    //.    you get 8 different disks with the file letter as the "piece"

    const pieceName = (blindnessLevel >= 2) ? oneMove.from[0] : pieceNameMap.get(oneMove.piece)

    oneMove.pieceName = pieceName
    oneMove.arrayIndex = i
    const fromSquare = oneMove.from
    const toFile = oneMove.to[0]
    const toSquare = oneMove.to

    var key = pieceName
    var value = []
    if (pieceMap.has(key) == false)
      pieceMap.set(key,[])
    value = pieceMap.get(key)
    value.push(oneMove)

    key = pieceName + "," + fromSquare
    if (pieceFromSquare.has(key) == false)
      pieceFromSquare.set(key,[])
    value = pieceFromSquare.get(key)
    value.push(oneMove)

    key = pieceName + "," + fromSquare + "," + toFile
    if (pieceFromSquareToFile.has(key) == false)
      pieceFromSquareToFile.set(key,[])
    value = pieceFromSquareToFile.get(key)
    value.push(oneMove)

    key = pieceName + "," + fromSquare + "," + toSquare
    if (pieceFromSquareToSquare.has(key) == false)
      pieceFromSquareToSquare.set(key,[])
    value = pieceFromSquareToSquare.get(key)
    value.push(oneMove)
  }


  // console.log("PieceMap",pieceMap)
  // console.log("PieceFromSquare",pieceFromSquare)
  // console.log("pieceFromSquareToFile",pieceFromSquareToFile)
  // console.log("pieceFromSquareToSquare",pieceFromSquareToSquare)

  // do we have <= 8 actual from -> to moves across all pieces?
  if (pieceFromSquareToSquare.size <= 8) {

    // convert map to array where each element is array with first element, the key
    const mapEntriesArray = Array.from(pieceFromSquareToSquare.entries());
    mapEntriesArray.sort((a, b) => a[0].localeCompare(b[0])); // For string keys
    const sortedMap = new Map(mapEntriesArray);

    var buttonArray = []
    for (var [key1, moves1] of sortedMap) {
      //console.log("Piece",key1,moves1)
      // build unique list of "from" squares
     
      // key is piece,from,to
      const realPieceName = key1.split(",")[0].substring(1)

      const sanDisplay = (blindnessLevel < 2) ? moves1[0].san : ""
      const buttonInfo = {
          index : realPieceName,
          piece : realPieceName,
          img : pieceImage(moves1[0].color,moves1[0].piece,blindnessLevel),
          fromString : "",
          info : sanDisplay + " (" + moves1[0].from + moves1[0].to + ")",
          moves : moves1
      }
      buttonArray.push(buttonInfo)
    }
    //console.log("BUTTONS",buttonArray)
    const buttonMatrix = calcButtonLayout(buttonArray,isPortrait)
    return (buttonMatrix)
  }

  // the pieces on the "from" squares have more than 8 possible moves but <= to file letters
  if (pieceFromSquareToFile.size <= 8) {
    // convert map to array where each element is array with first element, the key
    const mapEntriesArray = Array.from(pieceFromSquareToFile.entries());
    mapEntriesArray.sort((a, b) => a[0].localeCompare(b[0])); // For string keys
    const sortedMap = new Map(mapEntriesArray);

    var buttonArray = []
    for (var [key1, moves1] of sortedMap) {
      //console.log("Piece from square and to file letter",key1,moves1)
     
      // build unique list of "to" file letters
      var toFiles = []
      for (var i=0; i < moves1.length; i++)
        toFiles.push(moves1[i].to)
      const uniqueSet = new Set(toFiles);
      const uniqueArray = [...uniqueSet];
      uniqueArray.sort()
      //console.log("unique to files",key1,uniqueArray)
      
      const uniqueToFileString = collapseConsecutiveToSquares(uniqueArray,moves1[0].from)

      // key is piece,from,toFile
      const realPieceName = key1.split(",")[0].substring(1)
      const sanDisplay = (blindnessLevel < 2) ? moves1[0].san : ""

      const buttonInfo = {
          index : realPieceName,
          piece : realPieceName,
          img : pieceImage(moves1[0].color,moves1[0].piece,blindnessLevel),
          fromString : "",
          info : (moves1.length == 1) ? sanDisplay + " (" + moves1[0].from + moves1[0].to + ")" :uniqueToFileString + "    (" + moves1[0].from + ")",
          moves : moves1
      }
      buttonArray.push(buttonInfo)
    }
    //console.log("BUTTONS",buttonArray)
    const buttonMatrix = calcButtonLayout(buttonArray,isPortrait)
    return (buttonMatrix)
  }

  // there are 8 or fewer combinations of pieces and from squares.
  //      example: endgame with 2 rooks, 2 bishops and king.  all 5 distinct can be listed

  if (pieceFromSquare.size <= 8) {
    // convert map to array where each element is array with first element, the key
    const mapEntriesArray = Array.from(pieceFromSquare.entries());
    mapEntriesArray.sort((a, b) => a[0].localeCompare(b[0])); // For string keys
    const sortedMap = new Map(mapEntriesArray);

    var buttonArray = []
    for (var [key1, moves1] of sortedMap) {
      //console.log("Piece from square",key1,moves1)
     
      // build unique list of "to" squares
      var toFiles = []
      for (var i=0; i < moves1.length; i++)
        toFiles.push(moves1[i].to)
      const uniqueSet = new Set(toFiles);
      const uniqueArray = [...uniqueSet];
      uniqueArray.sort()
      //console.log("unique to files",key1,uniqueArray)
      
      const uniqueToFileString = uniqueArray.join(",")

      // key is piece,from,toFile
      const realPieceName = key1.split(",")[0].substring(1)
      const sanDisplay = (blindnessLevel < 2) ? moves1[0].san : ""
      const buttonInfo = {
          index : realPieceName,
          piece : realPieceName,
          img : pieceImage(moves1[0].color,moves1[0].piece,blindnessLevel),
          fromString : "",
          info : (moves1.length == 1) ? sanDisplay + " (" + moves1[0].from + moves1[0].to + ")" : moves1[0].from,
          moves : moves1
      }
      buttonArray.push(buttonInfo)
    }
    //console.log("BUTTONS",buttonArray)
    const buttonMatrix = calcButtonLayout(buttonArray,isPortrait)
    return (buttonMatrix)
  }

  // need to list each type of piece separately, will display where those pieces are "from
  // "
  // convert map to array where each element is array with first element, the key
  const mapEntriesArray = Array.from(pieceMap.entries());
  mapEntriesArray.sort((a, b) => a[0].localeCompare(b[0])); // For string keys
  const sortedMap = new Map(mapEntriesArray);

  var buttonArray = []
  for (var [key1, moves1] of sortedMap) {
    //console.log(`${key1} ${pieceName} -> ${moves1}`);
    //console.log("Piece",key1,moves1)
    // build unique list of "from" squares
    var fromSquares = []
    for (var i=0; i < moves1.length; i++)
      fromSquares.push(moves1[i].from)
    const uniqueSet = new Set(fromSquares);
    const uniqueArray = [...uniqueSet];
    uniqueArray.sort()
    //console.log("unique from squares",key1,uniqueArray)
    
    const realPieceName = key1.substring(1)
    const uniqueFromSquareString = uniqueArray.join(",")
    const sanDisplay = (blindnessLevel < 2) ? moves1[0].san : ""

    const buttonInfo = {
        index : realPieceName,
        piece : (uniqueArray.length == 1) ? realPieceName : realPieceName + "s",
        img : pieceImage(moves1[0].color,moves1[0].piece,blindnessLevel),
        fromString : "",
        info : (moves1.length == 1) ? sanDisplay + " (" + moves1[0].from + moves1[0].to + ")" : 
                (blindnessLevel >= 2) ? key1 : "",
        moves : moves1
    }
    buttonArray.push(buttonInfo)
  }
  //console.log("BUTTONS",buttonArray)
  const buttonMatrix = calcButtonLayout(buttonArray,isPortrait)
  return (buttonMatrix)
}